import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticleBreadcrumbResolver } from '@modules/content-api/resolver/article.resolver';
import { LightboxPageComponent } from '@modules/shared/lightbox/lightbox-page.component';

import { ArticlePageComponent } from './article-page.component';
const routes: Routes = [
  {
    path: '',
    component: ArticlePageComponent,
    resolve: {
      breadcrumb: ArticleBreadcrumbResolver,
    },
    data: {
      acceptsKeptBreadcrumbs: true,
    },
    children: [
      {
        path: ':resourceType/:resourceId',
        component: LightboxPageComponent,
        outlet: 'lightbox',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArticleRoutingModule {}
